export default {
  social(state, social) {
    state.social.list = social;
  }
};
